import moment from "moment";
export default {
  props: {
    automezzo: Object,
  },
  mounted() {
    const updateStatus = () => {
      this.last_update = moment.unix(this.automezzo.last_update).fromNow();
      this.reboot_ago = moment.unix(this.automezzo.last_reboot).fromNow();
      if (this.automezzo.in_base) {
        this.status =
          moment().diff(moment.unix(this.automezzo.last_update), "minutes") <
          this.automezzo.inbase_delay / 60000 + 1;
      } else {
        this.status =
          moment().diff(moment.unix(this.automezzo.last_update), "minutes") <
          this.automezzo.outbase_delay / 60000 + 1;
      }
    };
    updateStatus(); // Initial call to set the status immediately
    // Update status every second
    this.interval = setInterval(updateStatus, 1000);
    // Clear the interval when the component is destroyed
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.interval);
    });
  },
  data() {
    return {
      dialog: false,
      editDialog: false,
      hover: false,
      last_update: "",
      reboot_ago: "",
      inbase_dalay: this.automezzo.inbase_delay / 1000,
      outbase_delay: this.automezzo.outbase_delay / 1000,
      distance_threshold: this.automezzo.distance_threshold,
      loading_reset_gps: false,
      status: false,
      interval: null,
    };
  },

  methods: {
    elimina() {
      this.$store.dispatch("elimina_automezzo", this.automezzo.id);
    },
  },
  computed: {
    last_reboot() {
      return moment.unix(this.automezzo.last_reboot).format("DD/MM/YYYY HH:mm");
    },
    signal_icon() {
      if (this.status == false) {
        return "mdi-signal-off";
      }
      if (this.automezzo.signal > 0 && this.automezzo.signal <= 9) {
        return "mdi-signal-cellular-outline";
      } else if (this.automezzo.signal >= 10 && this.automezzo.signal <= 14) {
        return "mdi-signal-cellular-1";
      } else if (this.automezzo.signal >= 15 && this.automezzo.signal <= 19) {
        return "mdi-signal-cellular-2";
      } else if (this.automezzo.signal >= 20 && this.automezzo.signal <= 100) {
        return "mdi-signal-cellular-3";
      } else {
        return "mdi-signal-off";
      }
    },
  },
};
